import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';
import { ProfileService } from '../../../core/services/profile.service';
import { AppNotificationEvent, IAppNotificationEvent } from './models/app-notification-event';
import { AppNotificationGroup, IAppNotificationGroup } from './models/app-notification-group';
import { AppNotificationUserEvent, IAppNotificationUserEvent } from './models/app-notification-user-event.model';
import { environment } from "../../../../environments/environment";
import { map } from 'rxjs/operators';
@Injectable()
export class AppNotificationService {

    private readonly apiUrls = {
        'notificationGroup': `${environment.baseContext}/appnotification/groups`,
        'notificationEvents': `${environment.baseContext}/appnotification/userevents`,
        'notify': `${environment.baseContext}/appnotification/notifyuser`,
        'orgDefaultAppNotificationLevel': `${environment.baseContext}/commapi/common/appnotificationlevel`
    };
    readonly appNames: { [property: string]: string } = {
        'TSM': 'Quote Management',
        'GBY': 'Guided Buying',
        'SUP': 'Supplier',
        'OMS': 'Orders',
        'PRA': 'Procurement Assistant'
    };
    private events: AppNotificationEvent[] = [];
    private eventsSubject = new Subject<AppNotificationEvent[]>();

    private userData: AppNotificationUserEvent[] = [];
    private userDataSubject = new Subject<AppNotificationUserEvent[]>();

    private groups: AppNotificationGroup[] = [];
    private groupsSubject = new Subject<AppNotificationGroup[]>();

    constructor(private http: HttpClient, private profileService: ProfileService) {
    }

    watchNotificationEvents(): Observable<AppNotificationEvent[]> {
        return this.eventsSubject.asObservable();
    }

    watchUserData(): Observable<AppNotificationUserEvent[]> {
        return this.userDataSubject.asObservable();
    }

    watchNotificationGroups(): Observable<AppNotificationGroup[]> {
        return this.groupsSubject.asObservable();
    }

    /**
     * fetch notification groups based on apps
     * @param apps app names.
     * @returns void
     */
    getNotificationGroupsByApps(apps: string[]): void {
        let url = this.apiUrls.notificationGroup + '?';
        for (let i = 0; i < apps.length; i++) {
            url += 'app=' + apps[i];
            if (i < apps.length - 1) { url += '&'; }
        }
        this.http.get(url).subscribe(
            (response: IAppNotificationGroup[]) => {
                if (Array.isArray(response) && response.length > 0) {
                    this.groups = response.map((e: IAppNotificationGroup) => new AppNotificationGroup(e));
                    this.groupsSubject.next(this.groups);
                }
            }, (error: any) => { }
        );
    }

    /**
     * fetches notification events belonging to given group ids
     * @param groupIds number[]
     * @returns void
     */
    getEventsByGroupIds(groupIds: number[]): void {
        let url = this.apiUrls.notificationGroup + '/events?';
        for (let i = 0; i < groupIds.length; i++) {
            url += 'group=' + groupIds[i];
            if (i < groupIds.length - 1) { url += '&'; }
        }
        this.http.get(url).subscribe(
            (data: IAppNotificationEvent[]) => {
                if (Array.isArray(data) && data.length > 0) {
                    this.events = data.map((d: IAppNotificationEvent) => new AppNotificationEvent(d));
                    this.eventsSubject.next(this.events);
                }
            }, error => { });
    }

    getUserEventsData(): void {
        this.http.get(this.apiUrls.notificationEvents).subscribe(
            (data: IAppNotificationUserEvent[]) => {
                if (data && data.length > 0) { this.updateUserData(data); }
            }, (error: any) => { }
        );
    }

    private updateUserData(data: IAppNotificationUserEvent[]): void {
        this.userData = data.map((e: IAppNotificationUserEvent) => new AppNotificationUserEvent(e));
        this.userDataSubject.next(this.userData);
    }

    saveUserData(data: IAppNotificationUserEvent[]): Observable<boolean> {
        const url = this.apiUrls.notificationEvents + '/subscribe';
        return this.http.post(url, {
            'userEvents': data
        }, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json'
                })
            }).pipe(map((result: IAppNotificationUserEvent[]) => {
                if (result && result.length > 0) { this.updateUserData(result); }
                return true;
            }, (error: any) => {
                return false;
            }));
    }

    getProfile(): string {
        return this.profileService.fetchProfile();
    }

    notifyThisUser(data: object) {

        this.http.post(this.apiUrls.notify, data, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        }).subscribe(
            response => { },
            error => { }
        );
    }

    getOrganisationDefaultNotificationLevel(): Observable<any> {
        return this.http.get(this.apiUrls.orgDefaultAppNotificationLevel);
    }
}

